module.exports = __webpack_public_path__ + "img/device_cover_sag.74d40e79.svg";